// extracted by mini-css-extract-plugin
export default {"removeAnswered":"RemoveAnswered-removeAnswered-8b050e4c16e30765c2d8f1063ef3c56d"};